import { FC } from 'react'
import { IPropCheckbox } from '../../form.interface'

export const CheckboxDefault: FC<IPropCheckbox> = props => {
	return <input type='checkbox' {...props} />
}
